import { computed } from "@angular/core";
import { signalStoreFeature, type, withComputed } from "@ngrx/signals";
import { IProviderServiceState } from "./provider-service.state";

export const withProviderServiceComputed = signalStoreFeature(
    { state: type<IProviderServiceState>() },
    withComputed(({ providerServices }) => ({
        activeServices: computed(() => providerServices().filter(s => s.isActive)),
        inactiveServices: computed(() => providerServices().filter(s => !s.isActive)),
        totalServices: computed(() => providerServices().length)
    }))
);
